import React from 'react';
import { Nav, NavItem, } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const tabs = [
  { name: 'general', label: '一般設定', path: 'general' },
  { name: 'shops', label: 'モール連携', path: 'shops' },
  { name: 'senders', label: '配送元', path: 'senders' },
  { name: 'destinations', label: '配送先', path: 'destinations' },
  { name: 'otherLocations', label: 'ロケーション', path: 'otherLocations' },
  { name: 'extraSellers', label: '複数Amazonショップ連携', path: 'extraSellers' },
  { name: 'apiKeys', label: 'API連携', path: 'apiKeys' },
];

export default function SettingsTabs(props) {
  const { activeTab, } = props;

  return (
    <Nav tabs className="mb-3">
      {
        tabs.map(({ label, name, path }) => {
          return (
            <NavItem key={name}>
              <Link className={classnames('nav-link cursor-pointer', { active: activeTab === name })} to={`/settings/${path}`}>
                {label}
              </Link>
            </NavItem>
          )
        })
      }
    </Nav>
  );
};
